import { get } from 'lodash-es';

const properties: any = {};

export function getWmProjectProperties() {
  if (get(window, '_WM_APP_PROPERTIES')) {
    return get(window, '_WM_APP_PROPERTIES');
  } else {
    return properties;
  }
}

export function setWmProjectProperties(props: any) {
  Object.setPrototypeOf(properties, props);
}
